const PhotoMap = () => import('./PhotoMap.vue')

export default [
    {
        path: 'photo-map',
        name: 'photo-map',
        component: PhotoMap,
        meta: {perms: ['dashboard.view_feature_beta']},
    }
]